// Aspetto dei form pubblici: stessi valori di backend/src/modules/form/form.aspetto.ts.
// Grafiche di copertina e sfondi sono CSS puro (nessuna immagine da scaricare).

export const COPERTINE = {
  bcheers: 'radial-gradient(60% 130% at 88% 0,rgba(244,96,12,.75) 0,rgba(244,96,12,.18) 45%,transparent 70%),repeating-linear-gradient(90deg,rgba(255,255,255,.06) 0 1px,transparent 1px 26px),repeating-linear-gradient(0deg,rgba(255,255,255,.06) 0 1px,transparent 1px 26px),#161618',
  spiaggia: 'radial-gradient(120% 90% at 80% 10%,#FFE2A8 0,#FFC46B 22%,transparent 46%),linear-gradient(180deg,#5DB7D6 0,#9ED7E6 46%,#F2D49B 47%,#E9C17C 100%)',
  rete: 'repeating-linear-gradient(0deg,rgba(255,255,255,.55) 0 2px,transparent 2px 26px),repeating-linear-gradient(90deg,rgba(255,255,255,.55) 0 2px,transparent 2px 26px),linear-gradient(135deg,#F4600C,#C93E00)',
  tramonto: 'radial-gradient(60% 120% at 50% 110%,#FFB25B 0,#F4600C 35%,transparent 70%),linear-gradient(180deg,#2B1B3A 0,#7A2E3A 60%,#F4600C 100%)',
  notte: 'radial-gradient(70% 140% at 85% 0,rgba(244,96,12,.55) 0,transparent 60%),repeating-linear-gradient(90deg,rgba(255,255,255,.07) 0 1px,transparent 1px 22px),#17130F',
};

export const SFONDI = {
  bcheers: { pg: 'radial-gradient(900px 500px at 92% -8%,rgba(244,96,12,.08),transparent 60%),#F2F2F5', card: '#FFFFFF', tx: '#1D1D1F', sub: '#6E6E73', fl: '#E5E5EA', inp: '#F5F5F7' },
  sabbia:  { pg: 'linear-gradient(180deg,#F6EBD6,#EFDCB9)', card: '#FFFFFF', tx: '#24190F', sub: '#7A6B5C', fl: '#E7DCCB', inp: '#FBF8F3' },
  chiaro:  { pg: '#F1F2F4', card: '#FFFFFF', tx: '#15171A', sub: '#646A73', fl: '#E1E4E8', inp: '#F8F9FA' },
  scuro:   { pg: 'radial-gradient(90% 60% at 100% 0,rgba(244,96,12,.18),transparent 60%),#121012', card: '#1C191B', tx: '#F4EEE8', sub: '#A99E94', fl: '#332D2F', inp: '#151214' },
  arancio: { pg: 'repeating-linear-gradient(0deg,rgba(255,255,255,.14) 0 1px,transparent 1px 30px),repeating-linear-gradient(90deg,rgba(255,255,255,.14) 0 1px,transparent 1px 30px),#E8590C', card: '#FFFFFF', tx: '#1A1410', sub: '#6F6158', fl: '#EADFD6', inp: '#FBF7F4' },
};
// con la foto come sfondo le card restano chiare come nel tema B-Cheers
SFONDI.foto = SFONDI.bcheers;

export const TEMI = {
  bcheers:  { nome: 'B-Cheers',        copertina: 'bcheers',  sfondo: 'bcheers', colore: '#F4600C', caratteri: 'moderno',  campi: 'riquadri' },
  spiaggia: { nome: 'B-Cheers estate', copertina: 'spiaggia', sfondo: 'bcheers', colore: '#F4600C', caratteri: 'sportivo', campi: 'riquadri' },
  notte:    { nome: 'B-Cheers notte',  copertina: 'notte',    sfondo: 'scuro',   colore: '#F4600C', caratteri: 'sportivo', campi: 'riquadri' },
  rete:     { nome: 'B-Cheers rete',   copertina: 'rete',     sfondo: 'bcheers', colore: '#F4600C', caratteri: 'moderno',  campi: 'riquadri' },
};

export const COLORI = ['#F4600C', '#E0262E', '#1D6FB8', '#0F8B6E', '#1A1410', '#7A3FC4'];
export const ELENCO_COPERTINE = [['bcheers', 'B-Cheers'], ['spiaggia', 'Spiaggia'], ['rete', 'Rete'], ['tramonto', 'Tramonto'], ['notte', 'Notte'], ['nessuna', 'Nessuna']];
export const ELENCO_SFONDI = [['bcheers', 'Gestionale'], ['sabbia', 'Sabbia'], ['chiaro', 'Chiaro'], ['scuro', 'Scuro'], ['arancio', 'Arancio']];
export const ELENCO_CARATTERI = [['sportivo', 'Sportivo'], ['moderno', 'Moderno'], ['serif', 'Elegante']];
export const ELENCO_CAMPI = [['riquadri', 'A riquadri'], ['linea', 'Solo linea'], ['senzacard', 'Senza riquadro']];
export const MODALITA = [
  ['pagina', 'Pagina unica', 'Tutte le domande insieme, una sezione sotto l\'altra.'],
  ['sezioni', 'A sezioni', 'Un passo per ogni "Titolo e testo" del form, con barra dei passi.'],
  ['una', 'Una alla volta', 'Una domanda per schermata, si va avanti con Invio. Ideale da telefono.'],
];
// Altezza della copertina: [computer, telefono] in px
export const ALTEZZE = { bassa: [150, 120], media: [220, 170], alta: [320, 230] };
export const ELENCO_ALTEZZE = [['bassa', 'Bassa'], ['media', 'Media'], ['alta', 'Alta']];

export const ASPETTO_DEFAULT = {
  copertina: 'bcheers', copertina_img: null, copertina_pos: { x: 50, y: 50 }, copertina_altezza: 'media', slogan: true, slogan_1: 'Ci vediamo', slogan_2: 'sulla sabbia.',
  sfondo: 'bcheers', sfondo_img: null, colore: '#F4600C', caratteri: 'moderno', campi: 'riquadri', modalita: 'pagina',
  etichette: [], testo_invio: null,
};
export const aspettoCompleto = (a) => ({ ...ASPETTO_DEFAULT, ...(a || {}), copertina_pos: { ...ASPETTO_DEFAULT.copertina_pos, ...(a?.copertina_pos || {}) } });

// Tema scelto oggi, se le scelte coincidono con uno dei temi pronti
export const temaAttuale = (a) => Object.keys(TEMI).find(k => {
  const t = TEMI[k];
  return t.copertina === a.copertina && t.sfondo === a.sfondo && t.colore === a.colore && t.caratteri === a.caratteri && t.campi === a.campi;
}) || null;

// Testo leggibile sopra un colore (scuro o chiaro)
export const inchiostroSu = (hex) => {
  const n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#1A1410' : '#FFFFFF';
};

// Variabili CSS del tema per il contenitore .fv
export const variabiliTema = (a, url) => {
  const b = SFONDI[a.sfondo] || SFONDI.bcheers;
  const scuro = a.sfondo === 'scuro';
  const accento = scuro && a.colore === '#1A1410' ? '#F4EEE8' : a.colore; // un accento scuro su sfondo scuro non si legge
  const pgimg = a.sfondo === 'foto' && url.sfondo ? `linear-gradient(rgba(0,0,0,.28),rgba(0,0,0,.28)),url("${url.sfondo}") center/cover` : b.pg;
  return {
    '--a': accento, '--a-ink': inchiostroSu(accento), '--a2': scuro ? accento : '#C24B08',
    '--pg': pgimg, '--card': b.card, '--tx': b.tx, '--sub': b.sub, '--fl': b.fl, '--inp': b.inp,
  };
};

// Riduce una foto prima di caricarla: lato lungo al massimo 2400 px, JPEG 85%.
// Toglie anche i dati EXIF (posizione GPS del telefono).
export const riduciFoto = (file, maxLato = 2400) => new Promise((ok, ko) => {
  const img = new Image();
  const url = URL.createObjectURL(file);
  img.onload = () => {
    const scala = Math.min(1, maxLato / Math.max(img.naturalWidth, img.naturalHeight));
    const w = Math.round(img.naturalWidth * scala), h = Math.round(img.naturalHeight * scala);
    const c = document.createElement('canvas'); c.width = w; c.height = h;
    const ctx = c.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); ctx.drawImage(img, 0, 0, w, h);
    URL.revokeObjectURL(url);
    ok({ dati: c.toDataURL('image/jpeg', 0.85), larghezza: img.naturalWidth, altezza: img.naturalHeight });
  };
  img.onerror = () => { URL.revokeObjectURL(url); ko(new Error('Questa foto non si riesce ad aprire: prova con un JPG o PNG')); };
  img.src = url;
});
